const berserker = Object.freeze({
  id: 'berserker', definitionId: 'barbarian:berserker', classId: 'barbarian',
  name: 'Path of the Berserker', selectionLevel: 3,
  description: 'A Barbarian whose Rage erupts as heedless fury.',
  aliases: ['path-of-the-berserker'],
  features: Object.freeze([
    { id: 'barbarian:berserker:frenzy', name: 'Frenzy', level: 3, presentation: { kind: 'attack-modifier' }, contracts: [] },
    { id: 'barbarian:berserker:mindless-rage', name: 'Mindless Rage', level: 6, presentation: { kind: 'passive' }, contracts: [] },
    { id: 'barbarian:berserker:retaliation', name: 'Retaliation', level: 10, presentation: { kind: 'reaction' }, contracts: [] },
    { id: 'barbarian:berserker:intimidating-presence', name: 'Intimidating Presence', level: 14, presentation: { kind: 'bonus-action' }, contracts: [] },
  ]),
});
export default berserker;
